import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import Http from "../../Http";
import { Insurance_API } from "../../Helper";
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';
export default function TermLifeInsuranceCalculator() {
      const [insuranceData, setInsuranceData] = useState([]);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    age: 18,
    gender: 'Male',
    smoker: 'No',
    sumAssured: 2500000,
    coverageTillAge: 50,
    paymentMode: 'Monthly'
  });
  
  const [result, setResult] = useState(null);
  const [pieData, setPieData] = useState([]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: ['age', 'sumAssured', 'coverageTillAge'].includes(id) ? parseInt(value) : value
    });
  };

  const handleSliderChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: parseInt(value)
    });
  };

  const formatIndianCurrency = (value) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(value);
  };

  const calculatePremium = () => {
    const { age, gender, smoker, sumAssured, coverageTillAge, paymentMode } = formData;
    
    const baseRatePerLakhMonthly = 9.5; // ₹9.5/lakh/month (realistic)
    const gstRate = 0.18;
    const adminAnnual = 300;
    
    const ageFactor = age <= 35 ? 0.6 : 
                      age <= 30 ? 1.0 : 
                      age <= 35 ? 1.5 : 
                      age <= 40 ? 2.2 :
                      age <= 45 ? 3.0 : 
                      age <= 50 ? 4.5 : 
                      age <= 55 ? 6.0 : 8.0;
                      
    const genderFactor = gender === 'Female' ? 0.85 : 1.0;
    const smokerFactor = smoker === 'Yes' ? 1.3 : 1.0;
    const tenure = coverageTillAge - age;
    const tenureFactor = tenure <= 20 ? 1.0 : tenure <= 30 ? 1.15 : 1.3;
    
    const monthlyBase = baseRatePerLakhMonthly * (sumAssured / 100000) * ageFactor * genderFactor * smokerFactor * tenureFactor;
    const monthlyGST = monthlyBase * gstRate;
    const monthlyAdmin = adminAnnual / 12;
    
    const totalMonthly = monthlyBase + monthlyGST + monthlyAdmin;
    const totalAnnual = totalMonthly * 12;
    
    const newResult = {
      baseMonthly: monthlyBase,
      gstMonthly: monthlyGST,
      adminMonthly: monthlyAdmin,
      totalMonthly: totalMonthly,
      baseAnnual: monthlyBase * 12,
      gstAnnual: monthlyGST * 12,
      adminAnnual: adminAnnual,
      totalAnnual: totalAnnual,
      paymentMode: paymentMode
    };
    
    setResult(newResult);
    
    // Update pie chart data
    if (paymentMode === 'Monthly') {
      setPieData([
        { name: 'Base Premium', value: monthlyBase },
        { name: 'GST', value: monthlyGST },
        { name: 'Admin', value: monthlyAdmin }
      ]);
    } else {
      setPieData([
        { name: 'Base Premium', value: monthlyBase * 12 },
        { name: 'GST', value: monthlyGST * 12 },
        { name: 'Admin', value: adminAnnual }
      ]);
    }
  };

  // Calculate on initial render
  useEffect(() => {
    calculatePremium();
  }, []);

  const COLORS = ['#0088FE', '#00C49F', '#FFBB28'];
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            question: 'Is the Term Life Insurance Calculator free to use?',
            answer: "Yes, most online calculators are completely free and don't require any sign-up.",
          },
          {
            question: 'Does using the calculator guarantee the quoted premium?',
            answer: 'No, it gives an estimate. The actual premium may vary after underwriting.',
          },
          {
            question: 'Can I buy insurance directly after using the calculator?',
            answer: 'Yes, most platforms provide a direct link to purchase once the premium is estimated.',
          },
          {
            question: 'What is the minimum coverage I can enter in the calculator?',
            answer: 'Generally, the minimum sum assured starts from Rs. 25 lakhs, but it may vary.',
          },
          {
            question: 'How accurate are these premium estimates?',
            answer: 'They are fairly accurate but can differ post-medical tests and document verification.',
          },
          {
            question: 'Do calculators ask for income details?',
            answer: 'Yes, many calculators request your income to suggest appropriate coverage.',
          },
          {
            question: 'What if I lie about smoking in the calculator?',
            answer: 'It may show a lower premium, but your policy could be cancelled later due to false declaration.',
          },
          {
            question: 'Can I calculate premium for spouse or parents using this?',
            answer: 'Yes, provided you input their correct personal and health details.',
          },
          {
            question: 'Do these calculators support joint life insurance plans?',
            answer: 'Some advanced calculators offer joint policy estimates, but not all do.',
          },
          {
            question: 'Are riders included in the calculated premium?',
            answer: 'Only if you manually select them while using the calculator.',
          },
          {
            question: 'Can I compare different insurers on a single platform?',
            answer: 'Yes, aggregator platforms like Policybazaar offer comparison tools.',
          },
          {
            question: 'Will my premium stay the same every year?',
            answer: 'In term plans, premiums remain fixed throughout the term unless specified otherwise.',
          },
          {
            question: 'What if I input the wrong data?',
            answer: 'The estimate will be incorrect. Always cross-check your details before submission.',
          },
          {
            question: 'Do I need to consult an agent after using the calculator?',
            answer: 'Not necessarily, but professional guidance is helpful for large coverage decisions.',
          },
          {
            question: 'How often should I re-calculate my term insurance needs?',
            answer: 'Review your term insurance cover every 2–3 years or after major life events like marriage or childbirth.',
          },
        ];
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
    useEffect(() => {
        fetchInsuranceData();
      }, []);
    
      const fetchInsuranceData = async () => {
        try {
          const response = await Http.get(Insurance_API);
    
          // The response structure might have nested data
          // Check if response has an insurance property (like in the original fetch response)
          const data = response.insurance || response;
    
          // Filter the insurance data to show only Car category
          const carInsuranceData = Array.isArray(data)
            ? data.filter((insurance) => insurance.category_name === "Term Life")
            : [];
    
          setInsuranceData(carInsuranceData);
          setLoading(false);
        } catch (error) {
          setError("Failed to fetch insurance data");
          setLoading(false);
          console.error("Error fetching data:", error);
        }
      };
    
  return (
    <>
    <Helmet>
         <title>Term Insurance Calculator – Estimate Coverage & Premium</title>
         <meta  name='description' content='Calculate the required term insurance coverage and premium with our smart term insurance calculator.'/>
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/term-insurance-calculator" /> 
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">Term  Calculator</span>
        </li> 
      
      </ol>
    </nav> */}
        <div className="w-full flex justify-center items-center px-4 mt-20">
      <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
      <AdBanner displayOrder="1" />
      </div>
    </div>
    <div className="bg-gray-100 min-h-screen p-4 md:p-8 mt-8">
      <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="p-6 md:p-8">
          <h1 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-8">
             Term Insurance Premium Calculator
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Form Section */}
            <div className="space-y-6">
              <div>
                <label htmlFor="age" className="block text-gray-700 font-medium mb-2">
                  Age
                </label>
                <input
                  type="number"
                  id="age"
                  min="18"
                  max="60"
                  value={formData.age}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-gray-300 rounded-lg"
                  required
                />
                <input
                  type="range"
                  id="age"
                  min="18"
                  max="60"
                  value={formData.age}
                  onChange={handleSliderChange}
                  className="w-full h-2 bg-blue-200 rounded-lg appearance-none cursor-pointer mt-2"
                />
                <div className="flex justify-between text-xs text-gray-500 mt-1">
                  <span>18 Yr</span>
                  <span>60 Yr</span>
                </div>
              </div>

              <div>
                <label htmlFor="gender" className="block text-gray-700 font-medium mb-2">
                  Gender
                </label>
                <select
                  id="gender"
                  value={formData.gender}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-gray-300 rounded-lg"
                >
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div>
                <label htmlFor="smoker" className="block text-gray-700 font-medium mb-2">
                  Smoker
                </label>
                <select
                  id="smoker"
                  value={formData.smoker}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-gray-300 rounded-lg"
                >
                  <option value="No">No</option>
                  <option value="Yes">Yes</option>
                </select>
              </div>

              <div>
                <label htmlFor="sumAssured" className="block text-gray-700 font-medium mb-2">
                  Sum Assured (₹)
                </label>
                <input
                  type="number"
                  id="sumAssured"
                  min="2500000"
                  max="100000000"
                  step="100000"
                  value={formData.sumAssured}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-gray-300 rounded-lg"
                />
                <input
                  type="range"
                  id="sumAssured"
                  min="2500000"
                  max="100000000"
                  step="100000"
                  value={formData.sumAssured}
                  onChange={handleSliderChange}
                  className="w-full h-2 bg-blue-200 rounded-lg appearance-none cursor-pointer mt-2"
                />
                <div className="flex justify-between text-xs text-gray-500 mt-1">
                  <span>₹ 25 Lakhs</span>
                  <span>₹ 10 Crores</span>
                </div>
              </div>

              <div>
                <label htmlFor="coverageTillAge" className="block text-gray-700 font-medium mb-2">
                  Coverage Till Age
                </label>
                <input
                  type="number"
                  id="coverageTillAge"
                  min="50"
                  max="70"
                  value={formData.coverageTillAge}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-gray-300 rounded-lg"
                />
                <input
                  type="range"
                  id="coverageTillAge"
                  min="50"
                  max="70"
                  value={formData.coverageTillAge}
                  onChange={handleSliderChange}
                  className="w-full h-2 bg-blue-200 rounded-lg appearance-none cursor-pointer mt-2"
                />
                <div className="flex justify-between text-xs text-gray-500 mt-1">
                  <span>50 Yr</span>
                  <span>70 Yr</span>
                </div>
              </div>

              <div>
                <label htmlFor="paymentMode" className="block text-gray-700 font-medium mb-2">
                  Payment Frequency
                </label>
                <select
                  id="paymentMode"
                  value={formData.paymentMode}
                  onChange={handleInputChange}
                  className="w-full p-3 border border-gray-300 rounded-lg"
                >
                  <option value="Monthly">Monthly</option>
                  <option value="Annual">Annual</option>
                </select>
              </div>

              <button
                onClick={calculatePremium}
                className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium py-3 px-4 rounded-lg transition duration-300"
              >
                Calculate Estimated Premium
              </button>
            </div>

            {/* Results Section */}
            <div className="bg-gray-50 p-6 rounded-lg">
              <h2 className="text-xl font-bold text-gray-800 mb-6">Results</h2>
              
              {result && (
                <div className="space-y-6">
                  <div className="bg-white p-5 rounded-lg shadow">
                    <h3 className="text-lg font-semibold text-gray-700 mb-4"> Estimated Premium Details</h3>
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span className="text-gray-600">Sum Assured:</span>
                        <span className="font-medium">{formatIndianCurrency(formData.sumAssured)}</span>
                      </div>
                      
                      <div className="flex justify-between">
                        <span className="text-gray-600">Coverage Period:</span>
                        <span className="font-medium">{formData.coverageTillAge - formData.age} years</span>
                      </div>
                      
                      <div className="border-t border-gray-200 my-3"></div>
                      
                      <div className="flex justify-between">
                        <span className="text-gray-600">Base Premium:</span>
                        <span className="font-medium">
                          {formatIndianCurrency(result.paymentMode === 'Monthly' ? result.baseMonthly : result.baseAnnual)}
                        </span>
                      </div>
                      
                      <div className="flex justify-between">
                        <span className="text-gray-600">GST (18%):</span>
                        <span className="font-medium">
                          {formatIndianCurrency(result.paymentMode === 'Monthly' ? result.gstMonthly : result.gstAnnual)}
                        </span>
                      </div>
                      
                      <div className="flex justify-between">
                        <span className="text-gray-600">Admin Charges:</span>
                        <span className="font-medium">
                          {formatIndianCurrency(result.paymentMode === 'Monthly' ? result.adminMonthly : result.adminAnnual)}
                        </span>
                      </div>
                      
                      <div className="border-t border-gray-200 my-3"></div>
                      
                      <div className="flex justify-between text-lg font-bold">
                        <span className="text-gray-800">Total {result.paymentMode} Estimated Premium:</span>
                        <span className="text-blue-600">
                          {formatIndianCurrency(result.paymentMode === 'Monthly' ? result.totalMonthly : result.totalAnnual)}
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="bg-white p-5 rounded-lg shadow">
                    <h3 className="text-lg font-semibold text-gray-700 mb-2"> Estimated Premium Breakdown</h3>
                    <div className="h-64 w-full">
                      <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                          <Pie
                            data={pieData}
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            outerRadius={80}
                            fill="#8884d8"
                            dataKey="value"
                          >
                            {pieData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                          </Pie>
                          <Tooltip formatter={(value) => formatIndianCurrency(value)} />
                          <Legend />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                    
                  </div>
                  <h3 className="text-sm font-semibold text-gray-700 mb-2"> The price estimated is based on Industry standards. The actual plan price may vary.</h3>

                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
      <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
      <div className="w-full md:w-2/3 p-4 mx-auto">
      <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            What is a Term Life Insurance Plan?
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            A Term Life Insurance Plan is a pure life cover policy designed to offer financial protection to your loved ones in case of your untimely demise during the policy term. It is the most affordable form of life insurance that does not carry any maturity benefit. Instead, it offers a high coverage amount at relatively low premiums. The core purpose of a term plan is income replacement—ensuring your family can maintain their lifestyle, pay off debts, and meet future financial goals in your absence.
          </p>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            This plan typically runs for a predefined period, such as 10, 20, or 30 years. If the policyholder dies during this term, the insurer pays the agreed sum assured to the nominee. However, if the policyholder survives the term, no benefit is payable, unless it's a Return of Premium (ROP) plan.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Term Life Insurance Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A Term Life Insurance Calculator is a digital tool that estimates the premium you need to pay for a desired term life insurance coverage. This calculator considers multiple parameters such as your age, gender, income, smoking habits, desired sum assured, and policy tenure to determine the right premium.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              It acts as a financial planning aid, helping users compare different term plans and coverage options based on affordability and suitability. Unlike static brochures or policy pamphlets, a calculator gives you dynamic results tailored to your personal financial and health profile.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does a Term Life Insurance Premium Calculator Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The Term Life Insurance Premium Calculator uses predefined algorithms and actuarial data to estimate the premium based on:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Age and Gender:</strong> Younger applicants get lower premiums. Gender also impacts the cost as per life expectancy statistics.</li>
              <li><strong>Sum Assured:</strong> Higher the coverage amount, higher the premium.</li>
              <li><strong>Policy Tenure:</strong> Longer the term, higher the total premium but more secure the coverage period.</li>
              <li><strong>Occupation and Lifestyle Habits:</strong> High-risk jobs or habits like smoking lead to higher premiums.</li>
              <li><strong>Medical History:</strong> Pre-existing conditions can increase your premium or may even lead to exclusions.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The calculator processes these inputs in real-time and presents an estimated premium range. Some calculators also show a breakdown of premium components such as taxes and rider additions.
            </p>
          </div>
          <div className="container mx-auto px-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
          Popular Term Life Insurance Cards
            </h2>
  <div className="flex flex-col items-center space-y-6 mt-4">
    
  {insuranceData.slice(0, 5).map((insurance) => (
      <div
        key={insurance.id}
        className="w-full max-w-4xl bg-white rounded-2xl shadow hover:shadow-lg transition-shadow duration-300 p-4"
      >
        <div className="flex flex-col md:flex-row items-center md:items-start md:justify-between gap-6">
         
          <Link
            to={`/termlife-insurance/${insurance.page_url}`}
            className="w-full md:w-[180px] flex justify-center md:justify-start"
          >
            <img
              src={insurance.image}
              alt={insurance.page_title || "Insurance Provider"}
              className="h-18 object-contain"
            />
          </Link>

   
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-4 text-center md:text-left">
            <div>
              <p className="text-gray-500 text-sm font-medium">Premium Starting</p>
              <h4 className="text-lg font-bold">
              ₹{insurance.premium_start}
                
              </h4>
            </div>
            <div>
              <p className="text-gray-500 text-sm font-medium">Claim Settlement</p>
              <h4 className="text-lg font-bold">{insurance.claim_settlement}%</h4>
            </div>
            <div>
              <p className="text-gray-500 text-sm font-medium">Life Cover</p>
              <h4 className="text-lg font-bold">{insurance.network_garages}+</h4>
            </div>
          </div>


          <div className="flex flex-col sm:flex-row items-center gap-2 mt-4 md:mt-0">
            <a
              href={insurance.bank_link}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto"
            >
              <button className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded w-full sm:w-auto">
                Get Quote!
              </button>
            </a>
            <Link to={`/termlife-insurance/${insurance.page_url}`} className="w-full sm:w-auto">
              <button className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded w-full sm:w-auto">
                See Details
              </button>
            </Link>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How a Term Life Insurance Calculator Can Help You?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The term insurance calculator offers several benefits that go beyond just showing a price tag. Here’s how it aids in financial decision-making:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Saves Time:</strong> You can avoid multiple meetings with insurance agents and get results instantly.</li>
              <li><strong>Compare Plans:</strong> View premium rates from multiple insurers side-by-side.</li>
              <li><strong>Customized Results:</strong> Tailor your plan based on life stage, income, and dependents.</li>
              <li><strong>Avoid Over/Under Coverage:</strong> Calculate the right sum assured so you're not overpaying or under-insured.</li>
              <li><strong>Planning Add-ons:</strong> Include riders like critical illness, waiver of premium, or accidental death benefit to see how they affect the premium.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              It empowers you to make informed decisions and select a term plan that aligns with your long-term financial security goals.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Impact of Term Insurance Premium Calculation on Smokers
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Smoking significantly influences term insurance premiums. Insurers classify individuals as smokers or non-smokers based on their tobacco and nicotine consumption. Since smokers face higher health risks, they are charged higher premiums than non-smokers.
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Premium Difference:</strong> Smokers may pay up to 30-50% more than non-smokers of the same age and profile.</li>
              <li><strong>Medical Tests:</strong> Most insurers mandate a medical examination for smokers to assess health risks accurately.</li>
              <li><strong>Declaration of Habits:</strong> Non-disclosure of smoking habits can lead to claim rejection in the future.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              It's crucial for smokers to be transparent during the application process and use the calculator to understand the cost implications accurately.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Occupation Impacts Term Insurance Premium Calculation?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Your profession plays a crucial role in determining the premium amount. Term life insurance calculators factor in occupational risk when estimating the policy cost. Here’s how different jobs impact premiums:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>High-risk Jobs:</strong> Firefighters, miners, pilots, and construction workers may be charged a higher premium due to occupational hazards.</li>
              <li><strong>Sedentary Jobs:</strong> Office-goers, teachers, or IT professionals generally fall into the low-risk category and get lower premiums.</li>
              <li><strong>Self-Employed Individuals:</strong> Depending on the nature of the work, premiums can vary widely.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Understanding this impact helps applicants with high-risk professions prepare better and explore add-on covers for better protection.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What are the Benefits of Using a Term Life Insurance Calculator Online?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using an online calculator brings multiple advantages that streamline your policy selection process:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Free and Accessible:</strong> Most calculators are free to use without login requirements.</li>
              <li><strong>Real-time Results:</strong> Instantly view premiums based on dynamic inputs.</li>
              <li><strong>Educative Tool:</strong> Learn about various factors influencing insurance costs.</li>
              <li><strong>Better Planning:</strong> Estimate long-term financial commitments more accurately.</li>
              <li><strong>Transparency:</strong> Avoid hidden charges by seeing a detailed cost breakdown.</li>
              <li><strong>User Control:</strong> Adjust the sum assured, term, and riders to fit your budget.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Overall, an online calculator enhances user experience and brings clarity to a relatively complex product.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Much Term Life Insurance Cover Do I Need?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Determining the right term insurance cover depends on multiple personal and financial factors. While there's no one-size-fits-all formula, here are key considerations:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Income Replacement:</strong> A general rule is to opt for 10-15 times your annual income.</li>
              <li><strong>Outstanding Liabilities:</strong> Include home loans, personal loans, or any debts.</li>
              <li><strong>Future Expenses:</strong> Account for children’s education, marriage, and partner’s retirement needs.</li>
              <li><strong>Current Assets:</strong> Subtract your savings and investments from the required cover.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong> If your annual income is Rs. 10 lakhs, a sum assured between Rs. 1 crore to Rs. 1.5 crore is generally recommended. Adjust this figure based on lifestyle, liabilities, and inflation.
            </p>
          </div>
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Steps to Use the Term Life Insurance Calculator
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using a Term Life Insurance Calculator is a simple yet powerful way to estimate how much premium you'll need to pay for a desired life cover. It eliminates guesswork and gives you a data-backed approach to choosing the right plan. Here's how you can use it effectively:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Step-by-Step Guide:</strong>
            </p>
            <ul className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Enter Your Personal Details:</strong> Start by filling in your age, gender, and whether you are a smoker or non-smoker. These factors influence your premium significantly.</li>
              <li><strong>Select the Coverage Amount (Sum Assured):</strong> This is the lump sum amount your family would receive in the event of your unfortunate demise. Think of this as your financial safety net for your dependents.</li>
              <li><strong>Choose the Policy Term:</strong> This is the duration (in years) for which you want the life cover to be active. The longer the term, the higher the premium might be.</li>
              <li><strong>Enter Annual Income (Optional but Recommended):</strong> Some calculators ask for your income to recommend an ideal cover amount — usually 10 to 20 times your yearly income.</li>
              <li><strong>Select Payout Options:</strong> Choose how you want the sum assured to be paid — as a lump sum, regular monthly income, or a combination of both.</li>
              <li><strong>Click on ‘Calculate’ or ‘Get Quote’:</strong> The calculator will instantly show your estimated premium based on the details provided.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Example: How the Term Life Insurance Calculator Works
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Let’s take an example to understand how a term life insurance calculator helps you plan better:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Scenario:</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Rahul is a 30-year-old non-smoker working as an IT professional. He earns ₹10 lakh annually and wants to secure his wife and child with a life cover of ₹1 crore for a term of 30 years.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Steps Rahul Follows:</strong>
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Enters Age: 30</li>
              <li>Gender: Male</li>
              <li>Smoking Habit: No</li>
              <li>Sum Assured: ₹1 crore</li>
              <li>Policy Term: 30 years</li>
              <li>Annual Income: ₹10 lakh</li>
              <li>Payout Option: Lump sum</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Calculator Output:</strong>
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Estimated Monthly Premium: ₹850/month (approx.)</li>
              <li>Total Premium Paid Over 30 Years: ₹3.06 lakh</li>
              <li>Tax Savings: Eligible for deductions under Section 80C up to ₹1.5 lakh annually</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Conclusion:</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using the calculator, Rahul realizes that for just ₹850/month, he can protect his family with ₹1 crore in financial support. Without this tool, estimating an optimal cover and understanding the affordability would have been much more difficult.
            </p>
          </div>
        </div>
    
            <div className="w-full md:w-1/3 p-4">
              <div className="bg-white shadow-md rounded-lg overflow-hidden">
                <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
                  <h2 className="text-lg font-semibold ">Popular Categories</h2>
                </div>
                <div className="p-2 ">
                <ul>
                                    <Link to='/financial-tools-calculators/swp-calculator'>
                                        <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/fd-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/rd-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/nps-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/emi-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>
    
                                    </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>
    
                                    </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>
    
                                    </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>
    
                                    </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                        
                                    </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                    </Link>
                                    {/* {categories.map(category => (
           <Link key={category.id} to={`/category/${category.id}`}>
             <li className="py-2 border-b border-gray-300">{category.name}</li>
           </Link>
         ))} */}
                                </ul>
                            </div>
                        </div>

                             {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="2" />
      </div>
    </div>
  </div>
                        <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                            <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                                <h2 className="text-lg font-semibold">More Categories</h2>
                            </div>
                            <div className="p-2">
                            <ul>
                                    <Link to='/financial-tools-calculators/gratuity-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/APY-calculator'>
                                        <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/cagr-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/gst-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                    </Link>
                                    {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                    </Link> */}
                                    <Link to='/financial-tools-calculators/inflation-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/salary-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/brokerage-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                    </Link>
                                    <Link to='/financial-tools-calculators/tds-calculator'>
                                        <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                    </Link>
                    {/* {moreCategories.map(category => (
              <Link key={category.id} to={`/category/${category.id}`}>
                <li className="py-2 border-b border-gray-300">{category.name}</li>
              </Link>
            ))} */}
                  </ul>
                </div>
              </div>
    
            </div>
    
          </div>
          <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                    <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                    <div className="space-y-4">
                        {faqs.map((faq, index) => (
                            <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                                <button
                                    onClick={() => toggleAccordion(index)}
                                    className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                                >
                                    {faq.question}
                                    <Icon id={index} open={activeIndex} />
                                </button>
                                {activeIndex === index && (
                                    <div className="p-4 bg-gray-100">
                                        <p className="text-gray-700">{faq.answer}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
    </>
  );
}